<template>
  <div>
    <div class="alarm-progress slide">
      <span class="icon" v-show="!isPause"><a @click="pauseBtnClick"><i class="fas fa-pause"></i></a></span>
      <span class="icon" v-show="isPause"><a @click="playBtnClick"><i class="fas fa-play"></i></a></span>
    </div>
    <el-progress class="slider" type="circle" :percentage="percentage"></el-progress>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';

export default {
  name: 'WProgressTimer',
  data() {
    return {
      /**
       * 전체화면 슬라이드 갱신주기(s)
       * @type {Number}
       */
      refreshTimer: 0,
      /**
       * 전체화면에서 현재 active 상태인 슬라이드 index
       * @type {Number}
       */
      activeIndex: 0,
      /**
       * 전체화면 레이아웃(슬라이드) 총 개수
       * @type {Number}
       */
      layoutLenth: 0,
      /**
       * 타이머 내 progress 퍼센트
       * @type {Number}
       */
      percentage: 0,
      /**
       * Timer Interval 갱신주기(ms)
       * @type {Number}
       */
      interval: 0,
      /**
       * 갱신주기와 비교할 interval count값
       * @type {Number}
       */
      intervalCount: 0,
      /**
       * timer 컨트롤 값
       * @type {Number}
       */
      timerId: null,
      /**
       * 재생/일시정지 컨트롤 값
       * @type {Boolean}
       */
      isPause: false,
      changeTimerId: null,
    };
  },
  methods: {
    /**
     * 타이머 초기화 함수
     * @author JungJioon(ryunnnne)
     * @param  {[type]} activeIndex  전체화면에서 현재 active 상태인 슬라이드 index
     * @param  {[type]} layoutLenth  전체화면 레이아웃(슬라이드) 총 개수
     * @param  {[type]} refreshTimer 전체화면 슬라이드 갱신주기(초)
     * @param  {[type]} interval Timer Interval 갱신주기(ms)
     */
    initData(activeIndex, layoutLenth, refreshTimer, interval) {
      this.refreshTimer = isNil(refreshTimer) ? 5 : refreshTimer;
      this.percentage = 0;
      this.interval = isNil(interval) ? 200 : interval;
      this.intervalCount = 0;
      this.activeIndex = isNil(activeIndex) ? 0 : activeIndex;
      this.layoutLenth = isNil(layoutLenth) ? 0 : layoutLenth;
      this.isPause = false;
    },
    /**
     * 타이머 인터벌 함수
     * @author JungJioon(ryunnnne)
     */
    refreshInterval() {
      if (this.intervalCount > this.refreshTimer) {
        const self = this;
        self.stopTimer();
        this.percentage = 0;
        this.intervalCount = 0;
        this.changeTimerId = setTimeout(() => {
          if (self.activeIndex === self.layoutLenth) {
            self.activeIndex = 0;
          } else {
            self.activeIndex += 1;
          }
          self.$emit('onIndexItemClick', self.activeIndex);
        }, 300);
      } else {
        this.percentage += (100 / ((this.refreshTimer * (1000 / this.interval))));
        // this.percentage += (100 / ((this.refreshTimer) * 5));
        if (this.percentage > 100) {
          this.percentage = 100;
        }
        this.intervalCount += (this.interval / 1000);
        // this.intervalCount += 0.2;
      }
    },
    /**
     * 타이머 시작 함수 (인터벌 설정)
     * @author JungJioon(ryunnnne)
     */
    startTimer() {
      // this.timerId = setInterval(this.refreshInterval, 1000);
      this.timerId = setInterval(this.refreshInterval, this.interval);
    },
    /**
     * 타이머 중지 함수 (인터벌 clear)
     * @author JungJioon(ryunnnne)
     */
    stopTimer() {
      clearInterval(this.timerId);
    },
    /**
     * 일시정지 버튼 클릭
     * @author JungJioon(ryunnnne)
     */
    pauseBtnClick() {
      this.isPause = true;
      this.stopTimer();
    },
    /**
     * 재생 버튼 클릭
     * @author JungJioon(ryunnnne)
     */
    playBtnClick() {
      this.isPause = false;
      this.startTimer();
    },
  },
};
</script>

<style>
.dashboard-fullscreen .alarm-progress.slide {
  right: 2.5%;
}
.dashboard-fullscreen .el-progress.slider {
  z-index: 9;
  right: calc(2.5% - 2px);

}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/ProgressTimer.vue